<template>
  <div class="d-none"></div>
</template>

<script>
export default
{
  props: ["crossseller"],
  mounted()
  {
    this.$store.commit("setCrossSeller",this.crossseller);
  }
}
</script>
